import { supabase } from '@/integrations/supabase/client';

/**
 * Returns true if the given user has completed onboarding.
 * Checks quiz_results count > 0 OR profiles.category not null as fallback.
 * THROWS on errors so React Query can retry and preserve last known good value.
 */
export async function fetchOnboardingStatus(userId: string): Promise<boolean> {
  // 1) Primary check: quiz_results count
  const { count, error } = await supabase
    .from('quiz_results')
    .select('id', { count: 'exact', head: true })
    .eq('user_id', userId);

  if (!error && typeof count === 'number') {
    return count > 0;
  }

  // If quiz_results query failed, try fallback before throwing
  if (error) {
    // 2) Fallback: check profiles.category
    const { data: profile, error: profileError } = await supabase
      .from('profiles')
      .select('category')
      .eq('user_id', userId)
      .single();

    if (!profileError && profile?.category) {
      return true;
    }

    // Both failed — throw so React Query retries and keeps stale data
    throw new Error(`Onboarding status check failed: ${error.message}`);
  }

  return false;
}
